// extracted by mini-css-extract-plugin
export default {"container":"CompanyMenu_container__qLw8b","menu":"CompanyMenu_menu__qFrv3","menuContainer":"CompanyMenu_menuContainer__gPoNV","cardMini":"CompanyMenu_cardMini__8OgKr"};